import { useContext, useEffect, useState } from "react";
import * as _btn_ from "@Elementos/Boton";
import * as _div_ from "@Elementos/Div";
import * as _f_ from "@Funciones/funciones";
import ModalInformacion from "@ModalInformacion/ModalInformacion";

import { Contexto } from "@Componentes/App";

import "./PreConfirmacion.css";
export const PreConfirmacion = ({
  origen,
  texto,
  fBotonAceptar,
  fBotonCancelar,
  parametrosCancelar,
}) => {
  const { ecv_u, cv_u, usuarioSesion, esComputadora } = useContext(Contexto);
  const [v_u, ev_u] = useState({
    d_exito: false,
    i_procesandoApi: false,
  });
  return (
    <>
      <_div_.Div texto={texto} />
      <div className={"PreConfirmacionCSS-opciones"}>
        <_btn_.Boton
          texto={`Aceptar`}
          tipo="btn-2"
          procesando={v_u.i_procesandoApi}
          estilos={{
            color: "var(--color_verde_1)",
            fuente: "1rem",
          }}
          onClick={() => {
            fBotonAceptar?.();
          }}
        />
        <_btn_.Boton
          texto={`cancelar`}
          tipo="btn-2"
          procesando={v_u.i_procesandoApi}
          estilos={{
            color: "var(--color_rojo_1)",
            fuente: "1rem",
          }}
          onClick={() => {
            fBotonCancelar?.();
          }}
        />
      </div>
    </>
  );
};
